import styled from 'styled-components';

interface BottomSheetI {
  mobile?: boolean;
  'data-close'?: string;
  'data-active'?: string;
}

export const ModalWrapper = styled.div<BottomSheetI>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: ${props => (props['data-close'] === 'true' ? 'none' : 'block')};
`;

export const BottomSheetWrapper = styled.div<BottomSheetI>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: 20px 20px 0 0;
  padding: 20px;
  transform: ${props =>
    props['data-active'] === 'true' ? 'translateY(0)' : 'translateY(100%)'};
  transition: transform 0.3s ease-in-out;
  max-height: ${props => (props.mobile ? '80vh' : '60vh')};
  overflow-y: auto;
`;

export const BottomSheetHeader = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const HeaderIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
